import type { Point } from "../types/Point"

// The 128×128 master every frame is drawn on; a hotspot is a coordinate on it.
export class CursorGrid {
  static readonly SIZE = 128
  static readonly CENTER: Point = { x: CursorGrid.SIZE / 2, y: CursorGrid.SIZE / 2 }

  static clamp(coordinate: number) {
    return Math.max(0, Math.min(CursorGrid.SIZE - 1, coordinate))
  }
}
